import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import jump from "jump.js";

$(window).on("load", function() {
  if (!Abacus.PreventDefault.JumpTo) {
    
    let mainnav =
        (document.querySelector("#mainnav") &&
          document.querySelector("#mainnav").clientHeight) ||
        0,
      mastheadmast =
        (document.querySelector(".masthead .mast") &&
          document.querySelector(".masthead .mast").clientHeight) ||
        0,
        extraOffset = 0;

    function thisHeight(){
      return $(this).height();
    }
    $('.'+JumpToOptions.offsetCSSClass).each(function(index, elem){
      let thisElemMax = Math.max.apply(Math, $(elem).find(JumpToOptions.offsetChildElementsToInclude).map(thisHeight));
      extraOffset += Math.max($(elem).outerHeight(),thisElemMax);
    });
    JumpToOptions.offset = (mainnav > 0 ? mainnav : mastheadmast) + extraOffset;

    $(".storytext a").each(function() {
      new JumpTo(this);
    });

    if (location.hash) {
      if (!document.querySelector("#story")) return;
      window.scrollTo(0, 0);
      jump(document.querySelector("#story"), {
        duration: 0,
        offset: 0,
        callback: function(target) {
          jump(location.hash, {
            duration: 0,
            offset: (JumpToOptions.offset + 10) * -1
          });
        }
      });
    }
  }
});

let JumpToOptions = {
  duration: 500,
  offset: 0,
  offsetCSSClass: 'scrollto-add-offset',
  offsetChildElementsToInclude: '.widget'
};

class JumpTo extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(JumpToOptions, options);
    this.setUpEvents();
  }

  setUpEvents() {
    var self = this;
    this.element.on("click", function(evt) {
      if (this.hash) self.smoothScroll(this);
    });
  }

  smoothScroll(element) {
    function thisHeight(){
      return $(this).height();
    }
    let self = this, target = element.hash, offset = 0, mainnav =
    (document.querySelector("#mainnav") &&
      document.querySelector("#mainnav").clientHeight) ||
    0,
  mastheadmast =
    (document.querySelector(".masthead .mast") &&
      document.querySelector(".masthead .mast").clientHeight) ||
    0;
    history.pushState(null, target, target);
    $('.'+self.options.offsetCSSClass).each(function(index, elem){
      let thisElemMax = Math.max.apply(Math, $(elem).find(self.options.offsetChildElementsToInclude).map(thisHeight));
      offset += Math.max($(elem).outerHeight(),thisElemMax);
    });
    self.options.offset = (mainnav > 0 ? mainnav : mastheadmast) + offset;
    jump(target, {
      duration: self.options.duration,
      offset: (self.options.offset + 10) * -1
    });
  }
}

export { JumpTo };



// WEBPACK FOOTER //
// ./Javascript/core/classes/jumpto.class.js